// externals
import React from 'react';

// libraries
import { Modal, Button } from '@makemydeal/dr-ui-bricks-components';

// styles
import { DealRefreshModalContent, ButtonContainer, Description, Header } from './DealRefreshModalView.style';
import { ResponsiveHeading } from '../PageHeading/pageHeading.style';

export const DealRefreshModalView = ({ onRefresh }: { onRefresh: () => void }): React.JSX.Element => {
    return (
        <Modal className="trade-in-modal-layer">
            <DealRefreshModalContent data-testid="deal-refresh-modal">
                <Header>
                    <ResponsiveHeading level={3} weight="bold" data-testid="deal-refresh-modal-header">
                        Offer Updates Available
                    </ResponsiveHeading>
                    <Description level={6} data-testid="deal-refresh-modal-body">
                        You have new details to review. Refresh to see the latest updates to your offer.
                    </Description>
                </Header>
                <ButtonContainer>
                    <Button buttonStyle="primary" onClick={onRefresh} data-testid="deal-refresh-modal-refresh-button">
                        Refresh
                    </Button>
                </ButtonContainer>
            </DealRefreshModalContent>
        </Modal>
    );
};

export default DealRefreshModalView;
